import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getListItems = (query) => http.get(`${api}/compras-catalogo/list-items`, { params: { ...query } })

export {
  getListItems
}
